<template>
  <div class="App" :class="{'non-scrollable': cartStore.showCart.value}">
    <div class="AppContainer">
      <AppHeader />
      <div class="CartWrapper" v-if="cartStore.showCart.value">
        <Cart/>
      </div>
      <main>
        <Announcement />
        <SearchContainer/>
        <Navigation class="Navigation"/>
        <div class="AppInner">
          <NuxtPage />
        </div>
      </main>
      <AppFooter/>
      <div class="toastContainer">
        <TransitionGroup name="toast">
          <Toast v-for="(val, key) in toastStore.toasts.value" :key="key" :mode="val.mode">
            {{ val.message }}
          </Toast>
        </TransitionGroup>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineNuxtComponent, useNuxtApp } from '#imports'
import { Toast } from '@ka-nabellinc/ka-nabell-ui'
import AppHeader from '@/containers/Header'
import Cart from '@/containers/Cart'
import SearchContainer from '@/containers/Pokemon/Search/Single/Form' // TODO: カード種による出しわけ
import AppFooter from '@/containers/Footer'
import Sidebar from '@/containers/Sidebar'
import Navigation from '@/containers/Navigation'
import Announcement from '@/components/Announcement'
import { storeToRefs } from 'pinia'
import { DITokens } from '@/di'

export default defineNuxtComponent({
  components: {
    AppHeader,
    Cart,
    SearchContainer,
    AppFooter,
    Sidebar,
    Toast,
    Navigation,
    Announcement,
  },
  setup() {
    const { $container } = useNuxtApp()

    const toastStore = storeToRefs($container.resolve(DITokens.ToastStore))
    const cartStore = storeToRefs($container.resolve(DITokens.CartStore))

    // 単に画面遷移時にカートを閉じるとチラつきが発生するため、default layoutに戻ってきた際にカートを閉じる
    //（default以外ではカートはHeaderのv-ifで非表示になっているのでフラグはtrueのままで問題ない）
    onMounted(() => {
      cartStore.showCart.value = false
    })

    return {
      toastStore,
      cartStore
    }
  }
})
</script>

<style scoped>
/* TODO: 背景画像の設定 */
.App {
  width: 100%;
  position: relative;
}

.AppContainer {
  width: 100%;
  padding-top: 56px;
  margin: 0 auto;
}

@media screen and (min-width: 430px) {
  .AppContainer {
    width: 430px;
  }
}

.CartWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100svh;
  z-index: 100;
}

.Navigation {
  width: 100%;
}

main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.AppInner {
  display: flex;
  width: 100%;
  gap: 32px;
}

.toastContainer {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  height: auto;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 8px;
  z-index: 10001;
}

.toast-move,
.toast-enter-active,
.toast-leave-active {
  transition: all 0.4s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.non-scrollable {
  height: 100svh;
  overflow: hidden;
}
</style>
